"use client";
import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./GreenSolutions.css";
import BlueSectionDivider from "./BlueSectionDivider";
import {Link} from 'react-router-dom';

const stats = [
  { value: "+90", label: "Specialists" },
  { value: "+20", label: "Industry sectors" },
  { value: "78", label: "Customer NPS Score" },
  { value: "99%", label: "Recommendation Rate" },
  { value: "+300", label: "Projects delivered" }
];

const cards = [
  {
    icon: <img src="/icons/renewable.webp" alt="Renewable Energy" />,
    title: "Renewable Energy Management",
    desc: "Optimize your solar, wind, or hydro operations with data-driven solutions for forecasting, grid integration, and asset management."
  },
  {
    icon: <img src="/icons/smart.webp" alt="Smart Grid" />,
    title: "Smart Grid & Demand Management",
    desc: "Facilitate a two-way flow of energy with intelligent systems for grid optimization, demand response programs, and dynamic pricing."
  },
  {
    icon: <img src="/icons/sustainable.webp" alt="Sustainable Buildings" />,
    title: "Sustainable Building Technologies",
    desc: "Integrate energy-efficient systems for heating, ventilation, and lighting control, along with real-time monitoring and analytics."
  },
  {
    icon: <img src="/icons/precision.webp" alt="Precision Agriculture" />,
    title: "Precision Agriculture & Water Management",
    desc: "Leverage data insights to optimize irrigation practices, monitor soil health, and increase crop yields with minimal water usage."
  },
  {
    icon: <img src="/icons/circular.webp" alt="Circular Economy" />,
    title: "Circular Economy & Waste Reduction",
    desc: "Develop innovative solutions for waste sorting, recycling, and upcycling, promoting a closed-loop resource management system."
  },
  {
    icon: <img src="/icons/environmental.webp" alt="Environmental Monitoring" />,
    title: "Environmental Monitoring & Conservation",
    desc: "Implement real-time monitoring systems for air and water quality, deforestation detection, and wildlife habitat protection."
  }
];

export default function GreenSolutionsSection() {
  const [active, setActive] = useState("solutions");

  const sectionsToHighlight = [
    "solutions",
    "benefits",
    "tech stack",
    "faq",
    "contact us"
  ];

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const offset = 80;
      const scrollY = window.scrollY + offset;

      for (let i = sectionsToHighlight.length - 1; i >= 0; i--) {
        const section = document.getElementById(sectionsToHighlight[i]);
        if (section && section.offsetTop <= scrollY) {
          setActive(sectionsToHighlight[i]);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = (id) => {
    setActive(id);
    const section = document.getElementById(id);
    section?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      {/* Sticky Navbar for Green Solutions */}
      <div className="green-navbar">
        <div className="container">
          <ul>
            {["solutions", "benefits", "tech stack", "faq", "contact us"].map((item) => (
              <li key={item}>
                <a
                  onClick={() => handleClick(item)}
                  className={active === item ? "active" : ""}
                >
                  {item.toUpperCase()}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Section Content */}
      <section className="green-section" id="solutions">
        <div className="container">
        <div className="green-stats-row" data-aos="fade-up">
          {stats.map((stat, i) => (
            <div className="green-stat" key={i}>
              <div className="green-stat-value">{stat.value}</div>
              <div className="green-stat-label">{stat.label}</div>
            </div>
          ))}
          <BlueSectionDivider />
        </div>

        <div className="green-title-group" data-aos="fade-up">
          <div className="green-title">DIGITAL SOLUTIONS</div>
          <div className="green-title-blue">FOR THE DIFFERENT GREENTECH AREAS</div>
        </div>

        <div className="green-cards-grid">
          {cards.map((card, i) => (
            <div
              className="green-card"
              key={i}
              data-aos="fade-up"
              data-aos-delay={100 + i * 100}
            >
              <div className="green-card-icon">{card.icon}</div>
              <div className="green-card-title">{card.title}</div>
              <div className="green-card-desc">{card.desc}</div>
            </div>
          ))}
        </div>

        <div className="green-cta-row" data-aos="fade-up" data-aos-delay="600">
          <button className="green-cta-btn">
            <Link to="/contact">
            GET STARTED WITH YOUR GREENTECH DIGITAL PRODUCT
            </Link>
          </button>
        </div>
        </div>
      </section>
    </>
  );
}
